export default {
  MESSAGE_AND_GUESTS: 'MESSAGE_AND_GUESTS',
  RESERVATION_QUESTIONS: 'RESERVATION_QUESTIONS',
  POTLUCK: 'POTLUCK',
  CHECKOUT: 'CHECKOUT',
  MEMBERSHIP: 'MEMBERSHIP'
};
